import styled from '@emotion/styled'
import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { colors, fonts, metrics } from 'component-library/__styling/settings'
import { WeAreForAFLLogo } from 'component-library/logos/WeAreForAFLLogo/WeAreForAFLLogo'

const margin = metrics.thewest.margins
export const StyledTWStaticAFLCard = styled('div')({
    padding: calcRem(margin.md, margin.md, margin.sm),
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    position: 'relative',
    background: `${colors.white} linear-gradient(170deg, ${colors.white} 74%, ${colors.thewest.westblue} 74.3%, ${colors.thewest.westblue} 100%)`,

    [breakpoint('sm')]: {
        padding: calcRem(margin.sm),
        background: `${colors.white} linear-gradient(172deg, ${colors.white}, ${colors.white} 78%, ${colors.thewest.westblue} 78.3%, ${colors.thewest.westblue} 100%)`,
    },
})

export const StyledTWStaticAFLCardTextWrapper = styled('div')({
    paddingBottom: calcRem(margin.md),
    lineHeight: 1.2,
    fontFamily: fonts.thewest.serif,
    fontSize: calcRem(19),

    [breakpoint('sm')]: {
        fontSize: calcRem(17),
    },

    [breakpoint('md')]: {
        fontSize: calcRem(15),
    },
})

export const StyledTWStaticAFLCardText = styled('p')({
    margin: '0 0 16px 0',
})

export const StyledTWStaticAFLCardHeading = styled('h3')({
    margin: `0 0 ${calcRem(6)} 0`,
})

export const StyledWeAreForAFLLogo = styled(WeAreForAFLLogo)({
    marginTop: 'auto',
    marginLeft: 'auto',

    // Using pixel values to ensure correct rendering in IE and older android
    height: '24px',
    width: '148px',

    [breakpoint('sm')]: {
        height: '16px',
        width: '99px',
    },
})
